import { IonToggle } from "@ionic/react";
import styled from "styled-components";

export const StyledToggle: typeof IonToggle = styled(IonToggle)`
  --background-checked: var(--allie-color-primary-90);
  --handle-background-checked: white;
`;
